import qs from 'qs';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const refillList = (query) => axiosInstance.get('/refill/list', { params: { ...pickDevParams, ...query } });

export const refillListPagination = (query) => axiosInstance.get('/refill/list-pagination', { params: { ...pickDevParams, ...query } });

export const refillConfiguration = () => axiosInstance.get('/refill/configuration', { params: pickDevParams });

export const refillGetModes = (query) => axiosInstance.get('/refill/modes', { params: { ...pickDevParams, ...query } });

export const refillGetServices = (query) => axiosInstance.get('/refill/services', { params: { ...pickDevParams, ...query } });

export const viewRefillTaskUrl = (id) => axiosInstance.get(`/refill/view/${id}`, { params: pickDevParams });

export const superDetailsRefillUrl = (id) => axiosInstance.get(`/refill/details/${id}`, { params: pickDevParams });

export const cancelRefillTaskUrl = (id) => axiosInstance.post(`/refill/cancel/${id}`, qs.stringify(pickDevParams));

export const changeRefillStatusUrl = (id, status) => axiosInstance.post(`/refill/change-status/${id}`, qs.stringify({ status, ...pickDevParams }));

export const bulkUpdateRefillStatusUrl = (payload) => axiosInstance.post('/refill/bulk-status', qs.stringify({ ...payload, ...pickDevParams }));

export const bulkCancelRefillUrl = (tasks) => axiosInstance.post('/refill/bulk-cancel', qs.stringify({ ...tasks, ...pickDevParams }));
